import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "./dropdown-menu";
import { Button } from "./button";
import { MoreHorizontal } from "lucide-react";

interface RowAction {
  label: string;
  onClick: () => void;
  icon: React.ReactNode;
}

type DataTableRowActionsProps = {
  actions: (RowAction | "divider")[];
};

function DataTableRowActions({ actions }: DataTableRowActionsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Abrir menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Acciones</DropdownMenuLabel>
        {actions.map((action) => {
          if (action === "divider") {
            return <DropdownMenuSeparator />;
          }

          return (
            <DropdownMenuItem key={action.label}>
              <Button variant="ghost" onClick={action.onClick}>
                {action.icon}
                {action.label}
              </Button>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export { DataTableRowActions };
